import React, { useCallback, useState } from 'react';
import { message } from 'antd';

const UploadFile = ({ value, onChange, label }) => {
  const [fileName, setFileName] = useState('');

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });

  const handleChange = useCallback(
    async (event) => {
      const file = event.target.files[0];
      if (!file) return;

      if (file.type !== 'application/pdf') {
        message.error('Дозволено лише PDF файл');
        return;
      }

      const base64 = await toBase64(file);

      setFileName(file.name);
      onChange(base64);
    },
    [onChange]
  );

  return (
    <div className="upload-file__wrapper">
      <input
        type="file"
        id="upload-file__input"
        accept=".pdf"
        onChange={handleChange}
      />
      <div className="upload-file__wrap">
        <label htmlFor="upload-file__input" className="upload-file__label">
          {fileName || label}
        </label>
      </div>
    </div>
  );
};

export default UploadFile;
